export class FileTransformer {
  static transform(obj) {
    let file = {};

    file.id = obj.id;
    file.filename = obj.attributes.filename;
    file.url = obj.attributes.url;
    file.mime = obj.attributes.mime;
    file.createdAt = obj.attributes.created_at;
    file.updatedAt = obj.attributes.updated_at;

    return file;
  }
}
